import React from 'react';
import { useState, useEffect } from 'react';
import "./LearnCalMain.css"
import {Container} from 'react-bootstrap'
import Calender from "../LearningCalendar/MonthYearPicker/Calender"
import Home from '../../pages/Home';
import HomeNew from '../../pages/HomeNew';

function LearnCalMain() {
  const [fiscalYear, setFiscalYear] = useState('');

  useEffect(() => {
    const updateFiscalYear = () => {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth();
      const fy = month >= 8 ? year + 1 : year;
      setFiscalYear(`FY${String(fy).slice(-2)}`);
    };

    updateFiscalYear();
    const timer = setInterval(updateFiscalYear, 1000 * 60 * 60);

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      {/* Banner image */}
      <div>
        <img
          className="banner__image"
          src={process.env.PUBLIC_URL + "/images/LearningCalendar/at-new-calendar-banner.jpg"}
          alt="banner"
        />
      </div>

      {/* Subheading */}
      <Container fluid>
        <p className="subheading__container">
          Lateral L&TT calendarized programs/offerings on Technology, Innovation
          and Delivery learning for {fiscalYear}.
          <br />
          <span style={{fontSize: '14px'}}><em>*Time WBSe is not applicable for Blended/ Self-paced Trainings.</em></span>
          <br />
          <span>Note: The Old LKM Microsite Learning Calendar has been moved to our New <a href="https://atc.l-tt.accenture.com/Learning-Calendar" className='new-calendar-link'>L-TT Microsite Learning Calendar</a>. Please use the new learning calendar going forward.</span>
        </p>
       
     
      </Container>

      <Container fluid>
        <div className="container__width">
         
          {/* <Home/> */}
          <HomeNew/>
        </div>
      </Container>
    </>
  );
}

export default LearnCalMain;